import React from 'react';
import { CourierObj } from '../../fetch/fetchInbound';
import { ComboBoxCourierObj } from '../../ReusableComponents/ComboBox/ComboBoxCourierObj';
import { useGetCourierArray } from '../../hooks/useGetCourierArray';

export function EditCourierBox({
  currentCourier,
  setCourierObj,
}: {
  currentCourier: CourierObj;
  setCourierObj: (CourierObj: CourierObj) => void;
}): JSX.Element {
  const { courierArray, isLoading } = useGetCourierArray();

  return (
    <>
      {!isLoading && (
        <ComboBoxCourierObj
          defaultValue={currentCourier}
          placeHolderText={'Choose courier'}
          id="courierList"
          comboBoxItems={courierArray}
          onChange={(
            event,
            value: string | CourierObj | Array<string | CourierObj>,
            reason
          ) => {
            console.log('value that is set', value);
            setCourierObj(value as CourierObj);
          }}
        />
      )}
    </>
  );
}
